var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivities = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 1C5.676 1 5 1.676 5 2.5V3H2.5A1.5 1.5 0 0 0 1 4.5v8A1.5 1.5 0 0 0 2.5 14H9v-.086L8.086 13H2.5a.501.501 0 0 1-.5-.5V10h7V9H2V4.5c0-.277.227-.5.5-.5h11c.273 0 .5.223.5.5V9h1V4.5A1.5 1.5 0 0 0 13.5 3H11v-.5c0-.824-.676-1.5-1.5-1.5h-3Zm0 1h3c.281 0 .5.219.5.5V3H6v-.5c0-.281.219-.5.5-.5ZM7 7v1h2V7H7Zm5.5 2-1 1H10v1.5l-1 1 1 1V15h1.5l1 1 1-1H15v-1.5l1-1-1-1V10h-1.5l-1-1Zm0 1.414.586.586H14v.914l.586.586-.586.586V14h-.914l-.586.586-.586-.586H11v-.914l-.586-.586.586-.586V11h.914l.586-.586Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivities);
export default ForwardRef;